export class Card {
  id?: string;
  cardName: string;
  cardProvider: string;
  cardBrand: string;
  batchNumber: string;
  registrationDate: number;
  serialFrom: string;
  serialTo: string;
  numberOfCards: number;
  expirationDate: number;
  programId: string;
  programName: string;
  inventory: number;
  balance: number;

  status: boolean;
  expDate: number;
  cardNumber: number;
  dateCardAssigned: string;
  number?: string;

  constructor(formData?: any) {
    let data: any = !formData ? {} : formData;
    this.id = data.id || null;
    this.cardName = data.programName || null;
    this.cardProvider = data.cardProvider || null;
    this.cardBrand = data.cardBrand || null;
    this.batchNumber = data.batchNumber || null;
    this.registrationDate = data.registrationDate || null;
    this.serialFrom = data.serialFrom || null;
    this.serialTo = data.serialTo || null;
    this.numberOfCards = data.numberOfCards || null;
    this.expirationDate = data.expirationDate || null;
    this.programId  = data.programId || null;
    this.programName = data.programName || null;
    this.inventory = data.inventory || null;


  }
}
